<ngx-spinner type="ball-atom"></ngx-spinner>
<div class="component-container">
  <div class="component-header">
    <h2>Entry Supervision</h2>
  </div>

  <mat-tab-group>
    <mat-tab label="Simple Report">
      <div class="report-form">
        <form [formGroup]="simpleForm">
          <div class="form-fields">
            <mat-form-field appearance="fill" class="form-field">
              <mat-label>User</mat-label>
              <mat-select formControlName="userId">
                <mat-option value="">All Users</mat-option>
                @for (user of users; track user.id) {
                  <mat-option [value]="user.id">{{ user.fullName }}</mat-option>
                }
              </mat-select>
            </mat-form-field>

            <mat-form-field appearance="fill" class="form-field">
              <mat-label>Date</mat-label>
              <input matInput [matDatepicker]="datePicker" formControlName="date">
              <mat-datepicker-toggle matIconSuffix [for]="datePicker" />
              <mat-datepicker #datePicker />
            </mat-form-field>

            <mat-form-field appearance="fill" class="form-field">
              <mat-label>Period</mat-label>
              <mat-select formControlName="period">
                <mat-option [value]="null">None</mat-option>
                @for (p of periods; track p.value) {
                  <mat-option [value]="p.value">{{ p.label }}</mat-option>
                }
              </mat-select>
            </mat-form-field>
          </div>

          <button mat-raised-button color="primary" (click)="downloadSimpleReport()">
            <mat-icon>download</mat-icon>
            Download CSV
          </button>
        </form>
      </div>
    </mat-tab>

    <mat-tab label="Advanced Report">
      <div class="report-form">
        <form [formGroup]="advancedForm">
          <div class="form-fields">
            <mat-form-field appearance="fill" class="form-field">
              <mat-label>User</mat-label>
              <mat-select formControlName="userId">
                <mat-option value="">All Users</mat-option>
                @for (user of users; track user.id) {
                  <mat-option [value]="user.id">{{ user.fullName }}</mat-option>
                }
              </mat-select>
            </mat-form-field>

            <mat-form-field appearance="fill" class="form-field">
              <mat-label>Section</mat-label>
              <mat-select formControlName="section">
                <mat-option value="">All Sections</mat-option>
                @for (section of sections; track section) {
                  <mat-option [value]="section">{{ section }}</mat-option>
                }
              </mat-select>
            </mat-form-field>

            <mat-form-field appearance="fill" class="form-field">
              <mat-label>Year</mat-label>
              <mat-select formControlName="year">
                <mat-option [value]="null">All Years</mat-option>
                @for (year of measurements; track year) {
                  <mat-option [value]="year">{{ year }}</mat-option>
                }
              </mat-select>
            </mat-form-field>

            <mat-form-field appearance="fill" class="form-field">
              <mat-label>Country</mat-label>
              <mat-select formControlName="countryId">
                <mat-option value="">All Countries</mat-option>
                @for (country of countries; track country.id) {
                  <mat-option [value]="country.id">{{ country.name }}</mat-option>
                }
              </mat-select>
            </mat-form-field>
          </div>

          <button mat-raised-button color="primary" (click)="downloadAdvancedReport()">
            <mat-icon>download</mat-icon>
            Download CSV
          </button>
        </form>
      </div>
    </mat-tab>
  </mat-tab-group>
</div>
